"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.querystringDetector = void 0;

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

var querystringDetector = {
  name: 'querystring',
  lookup: function lookup(options) {
    var url = new _url.default(window.location.href);
    var language = url.searchParams.get(options && options.lookupQueryString || '') || undefined;
    return language;
  }
};
exports.querystringDetector = querystringDetector;